import { render, staticRenderFns } from "./TransporterView.vue?vue&type=template&id=e01fc7ce&scoped=true"
import script from "./TransporterView.vue?vue&type=script&lang=js"
export * from "./TransporterView.vue?vue&type=script&lang=js"
import style0 from "./TransporterView.vue?vue&type=style&index=0&id=e01fc7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01fc7ce",
  null
  
)

export default component.exports